import gql from "graphql-tag";

export const ME_FOR_REFERRAL = gql`
  query meForReferral {
    shop {
      referralPointLimit
      referralPointAmount
    }
    me {
      id
      firstName
      lastName
      mobileNumber
      referralPoint {
        amount
        count
      }
      referral {
        code
      }
    }
  }
`;